<template>
	<div class="allbg">
		<!-- 头 -->
		<tyheader pageind="5"/>
		<section class="n_banner" :style=" 'background:url('+bannerurl+') center no-repeat;'"></section>
		<section class="n_title n_title01">
			<div class="w1400 pagetit">
				<div class="left" style="position: relative;z-index: 9;">
					<div class="n_nav">
						<a v-for="(item, index) in newsmenu" :key="index" :class="{on:newstabind == index}" @click="otherrout(item.code,index)" style="cursor: pointer;"><strong>{{item.title}}</strong></a>
						<!-- <a class="on" href="#"><strong>岁月双沟</strong></a>
						<a href="#"><strong>科技双沟</strong></a>
						<a href="#"><strong>醉美双沟</strong></a>
						<a href="#"><strong>苏酒文化客厅</strong></a>
						<a href="#"><strong>头排酒开窑节</strong></a>
						<a href="#"><strong>封藏大典</strong></a> -->
					</div>
				</div>
				<div class="right ">
					<div class="position"><a href="#">首页</a> <i>-</i> <a href="#">智慧文旅</a> <i>-</i> <em>{{newsmenutit}}</em> </div>
				</div>
			</div>
		</section>
		<section class="n_container">
			<div class="w1400">
				<div class="newsdetmod">
					<div class="leftmod">
						<div class="title_box center" style="width: 100%;">
							<div class="title">
								<h3>{{newsinfo.title}}</h3>
							</div>
						</div>
						<div class="" style="display: flex;justify-content: flex-start;">
							<div class="jqjd_tit">景点介绍</div>
							<a class="jqjd_tit" :href="newsinfo.panoramicView" target="_blank">点击查看景区全景图</a>
							<a class="jqjd_tit" href="http://www.sgjwhlyq.com/oders.php" target="_blank">在线购票</a>
						</div>
						<div class="wenlv-ny clearfix">
							<swiper class="midswiper1 fl" :options="swiperOption3" ref="mySwiper3">
								<swiper-slide v-for="(item,index) in newsinfo.banner" :key="index">
									<div class="swipertab" :style="'background-image: url('+imgurl + item +');'"></div>
								</swiper-slide>
								<div class="swiper-button-prev topbanner1" slot="button-prev"></div>
								<div class="swiper-button-next topbanner2" slot="button-next"></div>
							</swiper>
							<swiper class="midswiper2 fr" :options="swiperOption4" ref="mySwiper4">
								<swiper-slide v-for="(item,index) in newsinfo.banner" :key="index">
									<div class="swipertab" :style="'background-image: url('+imgurl + item +');'"></div>
								</swiper-slide>
								
							</swiper>
						</div>
						<div class="jqjd_tit1">景点介绍</div>
						<div class="contmod" v-html="newsinfo.content"></div>
						<div class="backpage" @click="backpage()">返回</div>
					</div>
					
					<div class="wrap-nlist">
						<div class="title-nlist">
							<img src="../assets/images/fjjd_img.jpg" >
						</div>
						<ul>
							<li v-for="(item,index) in newslist" v-if="index<4" :key="index">
								<img :src="imgurl+item.showImage" >
								<div class="ljsg">
									<div class="ljsgname">{{item.title}}</div>
									<a :href="'./zhwldet?code='+item.code+'&&ind=0'" class="ljsgbtn">去看看</a>
								</div>
							</li>
					  </ul>
					</div>
				</div>
				
				<div class="news-other">
					<p>上一篇：<a v-if="newsinfo.np" :href="'/zhwldet?code='+newsinfo.np.prev.code+'&ind='+newstabind">{{newsinfo.np.prev.title}}</a><span v-else>已经没有了</span></p>
					<p>下一篇：<a v-if="newsinfo.np" :href="'/zhwldet?code='+newsinfo.np.next.code+'&ind='+newstabind">{{newsinfo.np.next.title}}</a><span v-else>已经没有了</span></p>
				</div>
			</div>
		</section>
		<tyfooter></tyfooter>
	</div>
</template>

<script>
	let that = null
	import { swiper, swiperSlide } from "vue-awesome-swiper";
	import "swiper/dist/css/swiper.css";
	import tyheader from './header.vue'
	import tyfooter from './footer.vue'
	export default {
	  name: 'zhwldet',
		components: {
			swiper,
			swiperSlide,
			tyheader,
			tyfooter
		},
		metaInfo () {
			return {
				title: this.seot,
				meta: [   // set meta
					{                
						name: 'keyWords',
						content: this.seok
					},
					{
						name: 'description',
						content: this.seod
					}
				]
			}
		},
		data(){
			return{
				seot:this.COMMON.seotit,
				seod:this.COMMON.seodec,
				seok:this.COMMON.seokey,
				isshow:this.COMMON.isshow(),
				imgurl:this.COMMON.imgurl,
				swiperOption3:{
					loop: true,
					// loopedSlides: 5,
					slidesPerView: 1,
					// centeredSlides: true,
					spaceBetween: 0,
					// direction: 'vertical',
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
				},
				swiperOption4:{
					loop: true,
					// loopedSlides: 5,
					spaceBetween: 10,
					slidesPerView: 4,
					centeredSlides: true,
					slideToClickedSlide: true,
					watchSlidesVisibility:true,
					// direction: 'vertical',
				},
				newscode:'',
				newsinfo:'',
				newstabind:[],
				newsmenu:'',
				newsmenutit:'',
				newslist:'',
				bannerurl:''
			}
		},
		created() {
			that =this
		},
		computed:{
			swiper3() {
			  return this.$refs.mySwiper3.swiper;
			},
			swiper4() {
			  return this.$refs.mySwiper4.swiper;
			}
		},
		mounted() {
			let that = this
			this.newscode = this.$route.query.code
			that.newstabind = this.$route.query.ind
			this.getmenulist()
			this.getnewsdetail()
			this.getnewslist()
			this.$nextTick(() => {
				const swiperTop = this.$refs.mySwiper3.swiper
				const swiperThumbs = this.$refs.mySwiper4.swiper
				swiperTop.controller.control = swiperThumbs
				swiperThumbs.controller.control = swiperTop
			})
			that.$axios.post('/w/menu').then(function (response) {
				that.bannerurl = that.imgurl + response.data[4].banner
			}).catch(function (error) {
					console.log(error);
			});
			
			that.$axios.post('/w/pageseo?address='+'/zhwldet').then(function (response) {
				if(JSON.stringify(response.data) != "{}"){
					// that.seot = response.data.seoTitle
					that.seok = response.data.seoKey
					that.seod = response.data.seoDes
				}
			}).catch(function (error) {
					console.log(error);
			});
		},
		methods:{
			backpage(){
				this.$router.go(-1)
			},
			getnewsdetail(){
				let that = this
				this.$axios.post('/w/art?menuCode=&&amount=&&page=&&code='+that.newscode).then(function (response) {
					document.title = response.data.list[0].title
					response.data.list[0].time = response.data.list[0].time.split(' ')[0]
					response.data.list[0].banner = response.data.list[0].banner.split(',')
					that.newsinfo = response.data.list[0]
					that.newsmenutit = response.data.list[0].menu
					that.seot = response.data.list[0].title + ' - 江苏双沟酒业股份有限公司'
				})
				.catch(function (error) {
					console.log(error);
				});
			},
			getnewslist(num,ind){
				let that = this
				this.$axios.post('/w/art?code=&&amount=&&page=&&menuCode='+'1631172567742').then(function (response) {
					response.data.list.forEach((val,ind) => {
						val.time = val.time.split(' ')[0]
					})
					that.newslist = response.data.list
				})
				.catch(function (error) {
					console.log(error);
				});
			},
			getmenulist(){
				let that = this
				this.$axios.post('/w/menu?code=1631172517536').then(function (response) {
					that.newsmenu = response.data
					
				})
				.catch(function (error) {
					console.log(error);
				});
			},
			otherrout(num,ind){
				this.$router.push({path:'/zhwl',query: {type:num,ind:ind}})
			}
		},
		watch:{
			
		}
	}
</script>

<style scoped="scoped">
	article, aside, footer, header, nav, section {display: block;}
	img {
	    border-style: none;
	    max-width: 100%;
	    vertical-align: top;
	    width: auto!important;
	    height: auto!important;
	}
	.n_banner {height: 70vh;background-size: cover !important;}
	.n_title {height: 74px;border-bottom: #e7e7ea 1px solid;padding: 0;position: relative;background: #fff;}
	.pagetit{display: flex;justify-content: space-between;}
	.n_nav {position: relative;}
	.n_nav a {display: inline-block;height: 74px;font-size: 18px;float: left;line-height: 75px;color: #333333;text-align: center;box-sizing: border-box;position: relative;-moz-border-radius: 3px;-webkit-border-radius: 3px;border-radius: 3px;margin-right: 3.125rem;}
	.n_nav a:before {content: "";width: 0;height: 3px;position: absolute;bottom: 0;left: 0;background: #119e7f;transition: 0.6s ease-in-out;}
	.n_nav .on:before, .n_nav a:hover:before {width: 100%;}
	.position {line-height: 74px;color: #7b7b7d;padding-left: 22px;font-size: 14px;background: url(../assets/images/home_icon.png) left 30px no-repeat;}
	.position i {
		margin: 0px 5px;
		font-style: normal;
	}
	.position span, .position a, .position i {
		font-size: 14px;
		color: #7b7b7d;
		-moz-transition: all 0.36s ease-in-out;
		-webkit-transition: all 0.36s ease-in-out;
		-o-transition: all 0.36s ease-in-out;
		-ms-transition: all 0.36s ease-in-out;
		transition: all 0.36s ease-in-out;
	}
	.position em {
		font-size: 14px;
		color: #acacac;
		font-style: normal;
	}
	.n_container {
		background: url(../assets/images/n_container_bg.jpg) center bottom no-repeat #fff;
		background-size: 100% auto;
		width: 100%;
		    padding-bottom: 30px;
	}
	.container .title_box.center, .w1400 .title_box.center {
	    justify-content: center;
	}
	.container .title_box, .w1400 .title_box {
	    display: flex;
	    align-items: center;
	    padding-top: 30px;
	    padding-bottom: 35px;
	}
	.container .title_box .title h3, .w1400 .title_box .title h3 {
	    font-size: 32px;
	    font-stretch: normal;
	    line-height: 40px;
	    letter-spacing: 0px;
	    color: #333;
	    position: relative;
	    text-align: center;
	    font-family: 'syst','microsoft yahei';
	}
	.container .title_box .title h3:before, .w1400 .title_box .title h3:before {
	    content: '';
	    display: inline-block;
	    width: 22px;
	    height: 44px;
	    vertical-align: top;
	    background: url(../assets/images/png7.png) no-repeat;
	    background-position: left;
	    margin-right: 18px;
	}
	.container .title_box .title h3:after, .w1400 .title_box .title h3:after {
	    content: '';
	    display: inline-block;
	    width: 22px;
	    height: 44px;
	    vertical-align: top;
	    background: url(../assets/images/png7.png) no-repeat;
	    background-position: right;
	    margin-left: 18px;
	}
	.wenlv-ny {
	    padding-bottom: 40px;
			width: 100%;
			margin: 0 auto;
			/* display: flex;
			justify-content: space-between; */
	}
	.midswiper1{height: 33.75rem;cursor: pointer;width: 100%;}
	.midswiper2{height: 8rem;width: 100%;margin-top: 0.5rem;}
	.midswiper2 .swipertab,.midswiper1 .swipertab{width: 100%;height: 100%;background-size: cover;background-repeat: no-repeat;background-position: center;}
	.midswiper2 .swiper-slide {width: 100%;height: 160px;opacity: 1;}
	.midswiper2 .swiper-slide-active {opacity: 1;border: 3px solid #119e7f;height: calc(100% - 6px);}
	.midswiper1 .swiper-slide {width: 100%;height: 100%;opacity: 1;}
	.midswiper1 .swiper-slide-active {opacity: 1;}
	.news-other {
	    padding-top: 20px;
	    border-top: 1px solid #e5e5e5;
	    margin-top: 50px;
			text-align: left;
	}
	.news-other p {
	    font-size: 14px;
	    color: #71797e;
	    line-height: 20px;
	    padding-top: 10px;
	}
	.news-other p a {
	    color: #71797e;
	}
	.contmod{
		/* padding: 0px 4rem; */
		margin-top: 1rem;
	}
	.topbanner1, .topbanner2 {width: 60px;height: 60px;position: absolute;top: calc(50% - 10px);}
	.topbanner1{background-image:url(../assets/images/left-arrow.png);background-size: 100% 100%;}
	.topbanner2{background-image:url(../assets/images/right-arrow.png);background-size: 100% 100%;}
	.jqjd_tit {
	    height: 40px;
	    line-height: 40px;
	    color: #fff;
	    background: url(../assets/images/txt_bg.gif) 0 0 no-repeat;
	    background-size: 100% 100%;
	    text-align: center;
	    font-size: 16px;
			padding: 0px 10px;
			margin-right: 20px;
			margin-bottom: 20px;
	}
	.jqjd_tit1{width: 110px;height: 40px;
	    line-height: 40px;
	    color: #fff;
	    background: url(../assets/images/txt_bg.gif) 0 0 no-repeat;
	    background-size: 100% 100%;
	    text-align: center;
	    font-size: 16px;}
	
	
	.newsdetmod{
		display:flex;
		justify-content: space-between;
	}
	.wrap-nlist {overflow: hidden;width: calc(30% - 40px);padding-left: 40px; border-left: 1px solid #eee;text-align: left;margin-top: 35px;max-width: 242px;}
	.ljsg{
		display: flex;
		justify-content: space-between;
		height: 42px;
		align-items: center;
	}
	.ljsgname{
		padding-top: 5px;
		color: #28742e;
		font-size: 16px;
		font-weight: 600;
	}
	.ljsgbtn{
		font-size: 14px;
		color: #fff;
		width: 80px;
		height: 25px;
		line-height: 25px;
		text-align: center;
		background: #e57c00;
		border-radius: 2px;
	}
	.wrap-nlist ul li {
		padding: 20px 0 2px;
		border-bottom: 1px dotted #dcdcdc;
	}
	.leftmod{padding-left: 0;padding-right: 40px;width: 74%;}
	
	@media screen and (max-width: 767px) {
		.n_title{height: 50px;}
		.n_nav a{height: 50px;line-height: 50px;}
		.position{line-height: 50px;background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAMCAYAAAC5tzfZAAAAuElEQVQokZXRoU4DQRQF0LOT0RtCkKTB9Qdo+QY0hg+ApAKaFQj6G8XVUlldW40kCMjK6josEMxsMkyWQK95L3PnJJNM1TSNnsxwh0XafyT2gDlu036PI1znF0IBVhnocoV1H6rxhIu+t+I89YcdOsMLxr+ALmM8YxSwxOAP0OUYjwGX+PgngknAK772QG3EAaqieECLIW6Kro4JlGia7SWqQgLlJ58UM0+M2GGD06z4zOZ7dv6G7TfQZhwU9L0NbQAAAABJRU5ErkJggg==) left 19px no-repeat;}
	  .left{width: 7rem;
	  height: 50px;
	  overflow: hidden;}
		.left{background: url(../assets/images/downarr.png) right 15px no-repeat ;background-size: 20px;}
		.left:hover{height:auto;background: url(../assets/images/downarr.png) right 15px no-repeat #ffffff;background-size: 20px;box-shadow: 0px 0px 10px rgb(0,0,0,0.5);}
		.newsdetmod .leftmod{width: 100% !important;}
		.midswiper1{
			height: 19.75rem;
		}
		.midswiper2{height: 5rem;}
		.topbanner2,.topbanner1{width: 30px;height: 30px;}
		.container .title_box .title h3, .w1400 .title_box .title h3{font-size: 22px;}
		.jqjd_tit,.jqjd_tit1{font-size: 10px;}
		.jqjd_tit1{width: 80px;height: 30px;line-height: 30px;}
		.jqjd_tit{height: 30px;line-height: 30px;}
		.n_nav a{margin-right: 0px;}
	}
</style>
